import { twJoin } from "tailwind-merge";

import logoDark from "@/assets/images/logo-dark.svg";
import { NavigationSidebarUserMenu } from "@/components/NavigationSidebar/NavigationSidebarUserMenu";
import { AskNobiNavigationItem } from "@/components/PortfolioSidebar/AskNobiNavigationItem";
import { Sidebar } from "@/components/Sidebar/Sidebar";
import type { SidebarBodyRootProps } from "@/components/Sidebar/types";
import { useConfig } from "@/providers/config/useConfig";

import { usePortfolioSidebarManager } from "./items";
import { PortfolioSidebarProjectsSection } from "./PortfolioSidebarProjectsSection";

interface PortfolioSidebarProps extends Omit<SidebarBodyRootProps, "children"> {}

export function PortfolioSidebar({
  isOpened,
  isCollapsed,
  onToggleOpen,
  onToggleCollapse,
  isFaded,
}: PortfolioSidebarProps): React.ReactNode {
  const { navigationItems, hasMultipleAdminProjects } = usePortfolioSidebarManager();
  const isNobiAvailable = useConfig("isNobiAvailable");

  return (
    <Sidebar.Root {...{ isOpened, isCollapsed, onToggleCollapse, onToggleOpen, isFaded }}>
      <Sidebar.Header>
        <span
          className={twJoin(
            "flex items-center md:h-control-md",
            isCollapsed ? "w-full justify-center px-space-sm" : "w-fit justify-start px-space-lg",
          )}
        >
          <img
            src={logoDark}
            className={twJoin("block transition-width duration-200", isCollapsed ? "w-control-md" : "w-brand-mark")}
            alt="Area of People logo"
          />
        </span>
      </Sidebar.Header>
      <Sidebar.Body
        renderHeader={hasMultipleAdminProjects ? () => <PortfolioSidebarProjectsSection /> : undefined}
        items={navigationItems}
        hasSeparationLineForChildren
      >
        {navigationItems.length > 0 && isNobiAvailable && <AskNobiNavigationItem />}
      </Sidebar.Body>
      {!isFaded && (
        <Sidebar.Footer>
          <NavigationSidebarUserMenu isPortfolio />
        </Sidebar.Footer>
      )}
    </Sidebar.Root>
  );
}
